// extracted by mini-css-extract-plugin
export default {"title":"ProjectForm_title__GPMVP","form-container":"ProjectForm_form-container__kOc3o"};